<template>
  <div>
    <div class="container max-w-screen-md">
      <wavy-card>
        <div class="-mb-36">
          <div class="absolute left-0 right-0 top-0 flex justify-center">
            <div class="-mt-12 text-6xl">
              <img src="@/assets/brand/icon.svg" class="w-auto inline-block h-16 p-2.5 bg-brand-black rounded-full" alt="Logo" />
            </div>
          </div>
          <div class="mt-8 text-center">
            <p class="font-bold text-center text-brand-black text-2xl">Upgrade to offer…<span class="italic">offers</span> to your customers.</p>
            <p class="font-semibold text-brand-brown text-center text-lg mt-1">
              Keep customers around longer by presenting discounts, pauses, and unlisted plans. Churnkey prevents up to 42% of cancellations.
            </p>
            <div class="mt-12">
              <router-link to="/upgrade">
                <el-button @click="goToBuilder" type="primary" class="text-lg font-semibold py-4">Upgrade Your Churnkey Account →</el-button>
              </router-link>
            </div>
          </div>
        </div>
      </wavy-card>
    </div>
    <div class="mt-80 relative max-h-screen overflow-y-hidden" style="max-height: 550px">
      <div class="lg:grid lg:grid-cols-2 lg:gap-4 py-8 px-4 container max-w-screen-xl sm:py-2 sm:px-6 lg:px-8">
        <div v-for="choice in choices" :key="choice" class="bg-white border-brand-sand border-2 rounded-lg relative px-6 py-4 mt-4 lg:mt-1">
          <div>
            <p class="text-brand-brown font-semibold text-sm">When a customer selects</p>
            <p class="text-brand-black font-bold text-xl">{{ choice }}</p>
            <p class="text-sm mb-2 font-medium text-gray-700 mt-4">…trigger the following offer</p>
            <div class="mt-2 h-24">
              <el-select placeholder="Select Offer" value="None" class="w-64">
                <el-option label="None" value="None"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="absolute top-0 w-full bg-gradient-to-b from-transparent to-white h-full"></div>
    </div>
  </div>
</template>

<script>
import WavyCard from '@/components/UI/WavyCard.vue';
import { STEP_TYPE } from '@/store/shared';

export default {
  name: 'OfferBuilderPreview',
  components: {
    WavyCard,
  },
  computed: {
    stepMap() {
      return this.$store.getters.blueprintStepMap;
    },
    surveyStep() {
      return this.stepMap[STEP_TYPE.SURVEY];
    },
    survey() {
      if (this.surveyStep) {
        return this.surveyStep.survey;
      }
      return null;
    },
    choices() {
      if (this.survey && this.survey.choices && this.survey.choices.length) {
        return this.survey.choices.map((c) => c.value);
      }
      return ['Too Expensive', 'No Longer Need', 'Technical Issues', 'Missing Features', 'Other'];
    },
  },
};
</script>
